import type { ComponentPropsWithoutRef } from 'react'

type Props = ComponentPropsWithoutRef<'svg'>

export function CrossIcon(props: Props) {
  return (
    <svg width="14" height="14" viewBox="0.6 0 14 14" fill="#1B1C1B" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.7906 1.28823C14.0745 1.00425 14.0745 0.543834 13.7906 0.259857C13.5066 -0.0241191 13.0462 -0.0241191 12.7622 0.259857L7.45905 5.56301L2.1559 0.259857C1.87193 -0.0241191 1.41151 -0.0241191 1.12753 0.259857C0.843557 0.543834 0.843557 1.00425 1.12753 1.28823L6.43068 6.59138L1.12753 11.8945C0.843557 12.1785 0.843557 12.6389 1.12753 12.9229C1.41151 13.2069 1.87193 13.2069 2.1559 12.9229L7.45905 7.61975L12.7622 12.9229C13.0462 13.2069 13.5066 13.2069 13.7906 12.9229C14.0745 12.6389 14.0745 12.1785 13.7906 11.8945L8.48741 6.59138L13.7906 1.28823Z" />
    </svg>
  )
}
